import { Component, Input, OnInit } from '@angular/core';
import { IBankCookieService } from '../../../globals/services/ibank-cookie.service';
import { BaseComponent } from '../../../globals/classes/base.component';
import { CookieBarState } from '../../classes/static/enums';

@Component({
	selector: 'cookie',
	template: require('./cookie.component.html'),
})
export class CookieComponent extends BaseComponent implements OnInit {
  public isVisible: boolean;
  
	constructor(private ibankCookieService: IBankCookieService) {
		super();
  }
  
	ngOnInit(): void {
		this.mortalize(this.ibankCookieService.state$).subscribe((state) =>
			this.handleCookieBarState(state)
		);
	}

	close(): void {
    this.ibankCookieService.hide();
  }
  
	acceptAllCookie(): void {
		this.ibankCookieService.acceptAll();
	}
	rejectAllCookie(): void {
		this.ibankCookieService.rejectAll();
	}
	manageCookie(): void {
		this.ibankCookieService.manage();
	}

	private handleCookieBarState(state: CookieBarState): void {
		this.isVisible = state === CookieBarState.visible;
	}
}